import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { validateInvitation, startSurvey, consumeInvitation } from '../api';
import toast from 'react-hot-toast';
import { CheckCircle, AlertCircle, Loader2, ArrowRight } from 'lucide-react';

const InvitationPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [validating, setValidating] = useState(true);
  const [valid, setValid] = useState(false);
  const [invitation, setInvitation] = useState(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    checkToken();
  }, [token]);

  const checkToken = async () => {
    try {
      const res = await validateInvitation(token);
      if (res.data.valid) {
        setValid(true);
        setInvitation(res.data.invitation);
      } else {
        setValid(false);
      }
    } catch (err) {
      setValid(false);
      toast.error(err.response?.data?.message || 'Lien invalide');
    }
    setValidating(false);
  };

  const handleStart = async (format) => {
    setStarting(true);
    try {
      const res = await startSurvey({ response_format: format });
      const sessionId = res.data.session_id;
      
      // Mark invitation as used
      await consumeInvitation(token, { session_id: sessionId });
      
      navigate('/enquete', { state: { sessionId, format, invitationToken: token } });
    } catch (err) {
      toast.error('Erreur de connexion');
      setStarting(false);
    }
  };

  if (validating) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8faf8', flexDirection: 'column', gap: '16px' }}>
        <Loader2 size={40} color="#2E7D32" style={{ animation: 'spin 1s linear infinite' }} />
        <p style={{ color: '#666', fontSize: '14px' }}>Vérification de votre invitation...</p>
      </div>
    );
  }

  if (!valid) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8faf8', padding: '24px' }}>
        <div style={{ textAlign: 'center', maxWidth: '400px', background: 'white', padding: '40px', borderRadius: '20px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
          <AlertCircle size={48} color="#c62828" style={{ marginBottom: '16px' }} />
          <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' }}>Lien invalide ou utilisé</h2>
          <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6', marginBottom: '24px' }}>
            Ce lien d'invitation n'existe pas ou a déjà été utilisé. Chaque lien est à usage unique.
          </p>
          <button onClick={() => navigate('/')}
            style={{ background: 'linear-gradient(135deg, #2E7D32, #4CAF50)', color: 'white', border: 'none', padding: '14px 32px', borderRadius: '12px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            Retour à l'accueil <ArrowRight size={16} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(160deg, #0d3d12 0%, #1B5E20 30%, #2E7D32 60%, #1a6b24 100%)', padding: '24px' }}>
      <div style={{ textAlign: 'center', maxWidth: '500px', background: 'white', padding: '40px', borderRadius: '20px', boxShadow: '0 8px 40px rgba(0,0,0,0.2)' }}>
        <CheckCircle size={48} color="#2E7D32" style={{ marginBottom: '16px' }} />
        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' }}>Invitation vérifiée</h2>
        
        {invitation?.phone && (
          <p style={{ fontSize: '14px', color: '#666', marginBottom: '24px' }}>
            Numéro : <strong>{invitation.phone}</strong>
          </p>
        )}
        
        <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6', marginBottom: '28px' }}>
          Votre invitation est valide. Choisissez votre format de réponse pour commencer l'enquête.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button onClick={() => handleStart('text')} disabled={starting}
            style={{ background: 'linear-gradient(135deg, #2E7D32, #4CAF50)', color: 'white', border: 'none', padding: '16px', borderRadius: '12px', fontSize: '15px', fontWeight: '600', cursor: starting ? 'default' : 'pointer', opacity: starting ? 0.7 : 1 }}>
            {starting ? 'Chargement...' : 'Répondre en texte'}
          </button>
          <button onClick={() => handleStart('audio')} disabled={starting}
            style={{ background: '#f0f0f0', color: '#333', border: 'none', padding: '16px', borderRadius: '12px', fontSize: '15px', fontWeight: '600', cursor: starting ? 'default' : 'pointer', opacity: starting ? 0.7 : 1 }}>
            {starting ? 'Chargement...' : 'Répondre en audio'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvitationPage;
